const getMobileHref = (link) => {
  let href = link.target || link.linkTarget || link.href || link.url;

  if (href) {
    const separator = href.includes("?") ? "&" : "?";

    if (link.clickCode) {
      href += `${separator}clk=${link.clickCode}`;
    }
  }

  return href;
};

export default getMobileHref;
